import { Box, Image, Text, Flex, Link } from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface DappInfo {
  icon: string;
  id: string;
  link: string;
}

const familyDapps: DappInfo[] = [
    {
      icon: '/dapps/ptpt.webp',
      id: 'ptpt',
      link: 'https://liff.line.me/2006551877-w0L9oAq4'
    },
    {
      icon: '/dapps/petpop.png',
      id: 'petpop',
      link: 'https://liff.line.me/2006961904-ryeoa0kv'
    },
  // Add more dapps as needed
];

export const FamilyDappBanner = () => {
  const { t } = useTranslation();
  const [selectedDapp, setSelectedDapp] = useState<DappInfo | null>(null);

  useEffect(() => {
    // Randomly select a dapp when component mounts
    const randomIndex = Math.floor(Math.random() * familyDapps.length);
    setSelectedDapp(familyDapps[randomIndex]);
  }, []);

  if (!selectedDapp) return null;

  return (
    <Link href={selectedDapp.link} isExternal>
      <Box
        bg="gray.100"
        borderRadius="12px"
        p={4}
        boxShadow="0px 4px 4px rgba(0, 0, 0, 0.1)"
        _hover={{ transform: 'translateY(-2px)', boxShadow: '0px 6px 6px rgba(0, 0, 0, 0.15)' }}
        transition="all 0.2s"
      >
        <Flex align="center" gap={4}>
          <Image
            src={selectedDapp.icon}
            alt={t(`familyDapps.${selectedDapp.id}.title`)}
            boxSize="48px"
            borderRadius="12px"
          />
          <Box>
            <Text fontWeight="bold" fontSize="lg" color="gray.800">
              {t(`familyDapps.${selectedDapp.id}.title`)}
            </Text>
            <Text fontSize="sm" color="gray.600">
              {t(`familyDapps.${selectedDapp.id}.description`)}
            </Text>
          </Box>
        </Flex>
      </Box>
    </Link>
  );
}; 